import o from"./form-content";var r=o;export{r as default};
//# sourceMappingURL=index.js.map
